import { Config } from "../config";
import { Service } from ".";

export const CryptoService = {
    /**
    * [LIST]
    */
    List() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.list, requestOptions);

    },
    ListERC20() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.listERC20, requestOptions);

    },
    PortfolioERC20(limit) {

        var requestOptions = {
            method: 'Get',
            headers: {
                "ice-cube": "I-gotta-say-it-was-a-good-day"
            }
        }

        return CryptoService.Common.Fetch(Config.service.crypto.portfolioERC20 + limit, requestOptions);

    },
    PortfolioTRC20(limit) {

        var requestOptions = {
            method: 'Get',
            headers: {
                "ice-cube": "I-gotta-say-it-was-a-good-day"
            }
        }

        return CryptoService.Common.Fetch(Config.service.crypto.portfolioTRC20 + limit, requestOptions);

    },
    ListTRC20() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.listTRC20, requestOptions);

    },

    ListSubTRC20() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.listSubTRC20, requestOptions);

    },

    ListSubERC20() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.listSubERC20, requestOptions);

    },

    Trc20CommissionFeeList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.trc20CommissionFeeList, requestOptions);
    },

    Trc20CommissionFeeUpdate(data) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return CryptoService.Common.Fetch(Config.service.crypto.trc20CommissionFeeUpdate, requestOptions);

    },
    

    /**
    * [QRCODE]
    */
    QrCode() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return CryptoService.Common.Fetch(Config.service.crypto.qrcode, requestOptions);

    },
    /**
    * [COIN_WITHDRAW]
    * @param {string} code
    */
    Coinwithdraw(data) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return CryptoService.Common.Fetch(Config.service.crypto.coinWithdraw, requestOptions);

    },
    AddressWhiteList() {

        var requestOptions = {
            method: 'GET',
            headers: Config.utilities.authorizedHeader(),
        }

        return CryptoService.Common.Fetch(Config.service.user.addressWhiteList, requestOptions);
    },
    CoinwithdrawERC20(data) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return CryptoService.Common.Fetch(Config.service.crypto.coinWithdrawERC20, requestOptions);

    },
    CoinwithdrawTRC20(data) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return CryptoService.Common.Fetch(Config.service.crypto.coinWithdrawTRC20, requestOptions);

    },
    /**
 * [COMMON]
 * @function Fetch
 */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {
                        Service.User.Logout();
                        window.location.reload();

                    } 
                    else if (response.status === 400) {
                        return response.json();
                    }
                    else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}